import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  IconButton,
  Text,
  Box,
  Flex,
  Portal,
} from '@chakra-ui/react';
import { BsChevronDown } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { encodeToken } from '../utils/TokenUtils';

const LANGUAGES = [
  { code: 'es', label: 'Español' },
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'ru', label: 'Русский' },
  { code: 'it', label: 'Italiano' },
  { code: 'ar', label: 'العربية' },
  { code: 'pt', label: 'Português' },
];

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const currentLang = (i18n.language || 'es').slice(0, 2).toLowerCase();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);

    const token = encodeToken({ language });

    axios.patch('/api/v1/user/language', { token })
      .catch(err => {
        console.error('❌ Error actualizando idioma:', err.response?.data || err);
      });
  };

  return (
    <Box w="full" px={1}>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        p={1.5}
        bg="whiteAlpha.100"
        borderRadius="lg"
        border="1px solid"
        borderColor="whiteAlpha.100"
      >
        <Text
          fontSize="11px"
          fontWeight="semibold"
          color="gray.400"
          fontFamily="mono"
          pl={2}
          letterSpacing="0.05em"
        >
          {t('IDIOMA') || 'IDIOMA'}
        </Text>
        <Flex alignItems="center" gap={1}>
          <Button
            size="xs"
            px={2.5}
            py={1}
            borderRadius="md"
            variant="solid"
            bg={currentLang === 'es' ? 'teal.500' : 'transparent'}
            color={currentLang === 'es' ? 'white' : 'gray.300'}
            _hover={{ bg: currentLang === 'es' ? 'teal.600' : 'whiteAlpha.200', color: 'white' }}
            onClick={() => changeLanguage('es')}
            fontWeight="bold"
            fontSize="11px"
            h="24px"
          >
            ES
          </Button>
          <Button
            size="xs"
            px={2.5}
            py={1}
            borderRadius="md"
            variant="solid"
            bg={currentLang === 'en' ? 'teal.500' : 'transparent'}
            color={currentLang === 'en' ? 'white' : 'gray.300'}
            _hover={{ bg: currentLang === 'en' ? 'teal.600' : 'whiteAlpha.200', color: 'white' }}
            onClick={() => changeLanguage('en')}
            fontWeight="bold"
            fontSize="11px"
            h="24px"
          >
            EN
          </Button>

          {/* Menú desplegable para idiomas adicionales */}
          <Menu>
            <MenuButton
              as={IconButton}
              aria-label="Más idiomas"
              icon={<BsChevronDown />}
              size="xs"
              variant="ghost"
              color="gray.400"
              h="24px"
              w="24px"
              minW="24px"
              _hover={{ bg: 'whiteAlpha.200', color: 'white' }}
            />
            <Portal>
              <MenuList bg="gray.800" borderColor="gray.700" zIndex={9999} boxShadow="dark-lg">
                {LANGUAGES.map(({ code, label }) => (
                  <MenuItem
                    key={code}
                    bg={currentLang === code ? 'teal.600' : 'gray.800'}
                    color="white"
                    fontWeight={currentLang === code ? 'bold' : 'normal'}
                    _hover={{ bg: 'teal.500', color: 'white' }}
                    onClick={() => changeLanguage(code)}
                    fontSize="sm"
                  >
                    {label}
                  </MenuItem>
                ))}
              </MenuList>
            </Portal>
          </Menu>
        </Flex>
      </Flex>
    </Box>
  );
};

export default LanguageSwitcher;
